<template>
	<div class="swiper">
		<el-carousel :interval="4000" arrow="never">
		    <el-carousel-item v-for="(item,index) in groupimg" :key="index">
		    	<div style="max-width:1920px;margin:0 auto;">
		     		<img :src="item.picUrl" @click="toUrl(item.url)"/>
		    	</div>
		    </el-carousel-item>
		  </el-carousel>
	</div>
	
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:'swiper',
				groupimg:[],
			}
		},
		methods:{
			getData(){
				this.axios({
		          method: 'get',
				  url: this.GLOBAL.bannerListApi
		        })
				.then((res)=>{
					console.log(res.data.data)
					this.groupimg=res.data.data;
				})
				.catch((err)=>{
					console.log(err)
				})
			},
			toUrl(url){
				if(url == null || url === ''){
					return;
				}
			    window.location.href = url;
			}
		},
		created(){
			this.getData();
		}
	}
</script>

<style lang="less">
@import url("../../../../styles/main.less");
.swiper{
	width: 100%;
	overflow:hidden;
	.el-carousel{
		width:100%;
	}
	.el-carousel__container{
		.height(400);
	}
	.el-carousel__item{
		img{
			max-width:1920px;
			margin:0 auto;
			width: 150%;
			position:absolute;
			left:-22%;
		}
	}
	
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Index/Icom/swiper.vue